import { useLocation } from 'react-router';
import { Trans, useLingui } from '@lingui/react/macro';

import { useClientCommunicationDrawerContext } from '@/components/comments/ClientCommunicationDrawer/ClientCommunicationDrawerContext';
import InlineText from '@/design_system/Typography/InlineText';
import IconEmail from '@/icons/Email.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { type TNotificationOfType } from '@/models/notification';

import { Comment } from './components/Comment';

export const ClientCommentAddedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'client_comment_added'>;
}) => {
  const { t } = useLingui();
  const location = useLocation();

  const { comment, request } = notification;
  const requestReference = request.reference;

  const { setIsClientCommunicationDrawerOpen } = useClientCommunicationDrawerContext();

  const isOnRequestOrItemPageAlready = location.pathname.startsWith(
    `/requests/${notification.request?.id}`
  );

  return (
    <BaseNotification
      icon={<IconEmail />}
      notification={notification}
      notificationLabel={t({
        id: 'notification.client-comment-added.label',
        message: `The client added a new message on ${requestReference}`,
      })}
      notificationHeader={(color) => (
        <Trans id="notification.client-comment-added">
          <InlineText weight="medium" color={color}>
            The client
          </InlineText>{' '}
          added a new message
        </Trans>
      )}
      notificationContent={<Comment comment={comment.content} />}
      notificationHref={
        isOnRequestOrItemPageAlready
          ? null
          : `/requests/${notification.request?.id}?openClientCommunication=true`
      }
      onAction={() => setIsClientCommunicationDrawerOpen(true)}
    />
  );
};
